import { render, staticRenderFns } from "./HppAdjPrintDetails_Total.vue?vue&type=template&id=96d15a9a&"
import script from "./HppAdjPrintDetails_Total.vue?vue&type=script&lang=js&"
export * from "./HppAdjPrintDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports